"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PatientRel;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _radio = _interopRequireDefault(require("@kyruus/radio"));
var _constants = require("../../lib/constants");
var _styles = require("./styles");
const patientRelMapping = {
  existing: _constants.ESTABLISHED_PATIENT,
  new: _constants.NEW_PATIENT
};
function PatientRel(_ref) {
  let {
    patientRelTitle,
    buttonConfig,
    patientRel,
    onSelect
  } = _ref;
  const options = (0, _map.default)(buttonConfig).call(buttonConfig, _ref2 => {
    let {
      button_text,
      patient_type,
      disabled = false
    } = _ref2;
    return {
      value: patientRelMapping[patient_type],
      label: button_text,
      disabled: disabled
    };
  });
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "PatientRel"
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    legend: patientRelTitle,
    options: options,
    selected: patientRel,
    mode: "buttons",
    buttonStyle: "primary",
    row: true,
    onChange: (_event, value) => onSelect(value),
    name: "patient-rel-option"
  }));
}
const propTypes = {
  patientRelTitle: _propTypes.node,
  buttonConfig: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    patient_type: _propTypes.string,
    button_text: _propTypes.node
  })).isRequired,
  onSelect: _propTypes.func.isRequired,
  patientRel: _propTypes.string
};
const defaultProps = {
  patientRelTitle: '',
  patientRel: ''
};
PatientRel.propTypes = propTypes;
PatientRel.defaultProps = defaultProps;
PatientRel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PatientRel",
  "props": {
    "patientRelTitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "patientRel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "buttonConfig": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "patient_type": {
              "name": "string",
              "required": false
            },
            "button_text": {
              "name": "node",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "onSelect": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};